module.exports = __webpack_public_path__ + "img/mizutamari-cut-04.746c9b13.jpg";